import { render } from "./WebHeader.vue?vue&type=template&id=2c8ea960"
import script from "./WebHeader.vue?vue&type=script&lang=js"
export * from "./WebHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__